import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-record\">\n<path d=\"M100,13.8c-30,0-61.4,6.6-90.1,17c9,61.4,41.8,117.5,90.1,155.4c48.4-37.8,80.9-93.9,90.1-155.4\n\tC161.3,20.4,130,13.8,100,13.8z M92.1,150.5C67.8,128.6,50.6,99.2,43.6,67c-1.3-6,2.2-12,8.1-13.8c15.7-4.8,32.3-7.7,48.4-7.7\n\tc16,0,32.6,2.9,48.3,7.7c5.9,1.8,9.4,7.8,8.1,13.8c-7.1,32.3-24.1,61.7-48.5,83.5C103.4,154.5,96.6,154.5,92.1,150.5z\" />\n<path d=\"M88.4,123.1c-9.2-10.1-16.2-22.2-20.5-35.2c-2.8-8.7,2.6-18.1,11.5-20c6.8-1.5,13.7-2.3,20.5-2.3c6.4,0,13,0.8,19.4,2.1\n\tc9.7,2,15.4,12,12.2,21.4c-4.3,12.7-11.1,24.3-20.1,34.1C105.4,129.9,94.6,129.9,88.4,123.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/record.svg
// module id = 1XyD
// module chunks = 3